function randomId(prefix: string): string {
  const value = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}_${value}`;
}

export function getVisitorId(): string {
  const key = 'cloudbtl.visitorId';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const created = randomId('visitor');
    localStorage.setItem(key, created);
    return created;
  } catch {
    return randomId('visitor');
  }
}

export function newSessionId(): string {
  return crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function loadAccessToken(linkId: string): string {
  try {
    return localStorage.getItem(`cloudbtl.accessToken.${linkId}`) ?? '';
  } catch {
    return '';
  }
}

export function saveAccessToken(linkId: string, token: string): void {
  try {
    localStorage.setItem(`cloudbtl.accessToken.${linkId}`, token);
  } catch {
    /* ignore */
  }
}

// ── 리퍼럴 토큰: 랜딩(?ref)에서 발급받아 저장, 가입 성공 시 소진 후 삭제 ──
const REFERRAL_TOKEN_KEY = 'cloudbtl.referralToken';

export function saveReferralToken(token: string): void {
  try {
    localStorage.setItem(REFERRAL_TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function loadReferralToken(): string {
  try {
    return localStorage.getItem(REFERRAL_TOKEN_KEY) ?? '';
  } catch {
    return '';
  }
}

export function clearReferralToken(): void {
  try {
    localStorage.removeItem(REFERRAL_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
